module.exports = __webpack_public_path__ + "img/icon-12.7b5d7f8a.svg";